export default __webpack_public_path__ + "static/media/bg28.82da8a77.jpg";